import { SVGProps, Ref, forwardRef } from 'react'
const SvgTravelCoverInsurance = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#TravelCoverInsurance_svg__a)"
    >
      <path d="M13.125 13.815a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0ZM11.875 20.065a3.125 3.125 0 1 1 6.25 0M3.125 13.815a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0ZM1.875 20.065a3.125 3.125 0 0 1 6.25 0M16.875 9.44a6.875 6.875 0 1 0-13.75 0h13.75ZM10 9.44v6.25M10 2.565v-1.25" />
    </g>
    <defs>
      <clipPath id="TravelCoverInsurance_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" transform="translate(0 .69)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgTravelCoverInsurance)
export default ForwardRef
